//  Isotransformation
//  from `enriched Text` to HTML element
//  and from HTML element to `enriched Text`
import { MENTIONED_USERS_ID, UNDESIRABLE_CHARACTERS } from 'src/constants/regex';

const getCleanNodeValue = (node) => {
  let safeNodeValue = node.nodeValue || '';
  safeNodeValue = safeNodeValue.replace(MENTIONED_USERS_ID, '@ [$1]');
  UNDESIRABLE_CHARACTERS.forEach(el => safeNodeValue = safeNodeValue.replace(el.pattern, el.replacement));
  return safeNodeValue;
};

// rough polyfill of innerText to have a homogeneous behaviour
export const parseNode = (node) => {
  let str = '';
  const mentionedUserIds = {};
  const childNodes = Array.from(node.childNodes);

  const recursive = (subNode, before, after) => {
    const { str: innerStr, mentionedUserIds: innerMentionedUserIds } = parseNode(subNode);
    Object.assign(mentionedUserIds, innerMentionedUserIds);
    str += `${before}${innerStr}${after}`;
  };

  childNodes.forEach((child) => {
    switch ((child as Node).nodeName) {
      // escape mentions or links
      case 'BUTTON': // used for mentions in simple editor/contenteditor !
      case 'A': {
        const id = (child as HTMLAnchorElement).getAttribute('data-id');
        if (!id) {
          recursive(child, '', '');
          break;
        }
        str += `@[${id}]`;
        mentionedUserIds[id] = true;
        break;
      }
      // replace unwanted mentions format
      // we use the same formatting than FB
      case '#text':
        str += getCleanNodeValue(child);
        break;
      case 'BR':
        if (node.lastChild === child && (node.nodeName === 'DIV' || node.nodeName === 'P')) {
          break;
        }
        str += '\n';
        break;
      case 'DIV':
      case 'P':
        recursive(child, '', '\n');
        break;
      case 'U':
        recursive(child, '[u]', '[/u]');
        break;
      case 'I':
      case 'EM':
        recursive(child, '[i]', '[/i]');
        break;
      case 'B':
      case 'STRONG':
        recursive(child, '[b]', '[/b]');
        break;
      default:
        recursive(child, '', '');
        break;
    }
  });
  return { str, mentionedUserIds };
};
